// extracted by mini-css-extract-plugin
export default {"privacyPolicyPage":"style_privacyPolicyPage__ldF5F","pageTitle":"style_pageTitle__CdgNk","infoList":"style_infoList__XVNJN"};